/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import SVG from "react-inlinesvg";
import { Dropdown } from "react-bootstrap";
import objectPath from "object-path";
import ApexCharts from "apexcharts";
import {
  currencyFormatter,
  toAbsoluteUrl,
} from "../../../../_metronic/_helpers";
import {
  DropdownCustomToggler,
  DropdownMenu4,
} from "../../../../_metronic/_partials/dropdowns";
import { useHtmlClassService } from "../../../../_metronic/layout";
import moment from "moment";

export function ProgressWidget({
  className,
  chartColor = "danger",
  dataDonationThisMonth,
}) {
  const uiService = useHtmlClassService();
  const [dataProgress, setDataProgresss] = useState([]);
  const layoutProps = useMemo(() => {
    return {
      colorsGrayGray500: objectPath.get(
        uiService.config,
        "js.colors.gray.gray500"
      ),
      colorsGrayGray300: objectPath.get(
        uiService.config,
        "js.colors.gray.gray300"
      ),
      colorsThemeBaseColor: objectPath.get(
        uiService.config,
        `js.colors.theme.base.${chartColor}`
      ),
      colorsThemeLightColor: objectPath.get(
        uiService.config,
        `js.colors.theme.light.${chartColor}`
      ),
      fontFamily: objectPath.get(uiService.config, "js.fontFamily"),
    };
  }, [uiService, chartColor]);

  function mappingDataDonation(params) {
    let dataTemp = [];
    let dateTemp = [];
    params.forEach((item, index) => {
      let data = item.total_penerimaan_donasi
        ? +item.total_penerimaan_donasi
        : 0;
      dataTemp.push(data);

      let date = index + 1;
      dateTemp.push(date);
    });
    return {
      donation: dataTemp,
      date: dateTemp,
    };
  }

  useEffect(() => {
    const element = document.getElementById("kt_tiles_widget_1_chart");

    if (!element) {
      return;
    }

    const { donation, date } = mappingDataDonation(dataDonationThisMonth);

    const options = getChartOption(layoutProps, donation, date);
    const chart = new ApexCharts(element, options);
    chart.render();
    return function cleanUp() {
      chart.destroy();
    };
  }, [layoutProps, dataDonationThisMonth]);

  const currentMonth = new Date().getMonth();

  const monthName = () => {
    let name = "";
    switch (currentMonth) {
      case 0:
        name = "Januari";
        break;
      case 1:
        name = "Februari";
        break;
      case 2:
        name = "Maret";
        break;
      case 3:
        name = "April";
        break;
      case 4:
        name = "Mei";
        break;
      case 5:
        name = "Juni";
        break;
      case 6:
        name = "Juli";
        break;
      case 7:
        name = "Agustus";
        break;
      case 8:
        name = "September";
        break;
      case 9:
        name = "Oktober";
        break;
      case 10:
        name = "November";
        break;
      case 11:
        name = "Desember";
        break;

      default:
        break;
    }
    return name;
  };

  return (
    <>
      {/* begin::Tiles Widget 1 */}
      <div className={`card card-custom ${className}`}>
        {/* begin::Header */}
        <div className="card-header border-0 pt-5">
          <div className="card-title">
            <div className="card-label">
              <div className="font-weight-bolder">Transaksi Donasi</div>
              {/* <div className="font-size-sm text-muted mt-2">
                890,344 Transaksi
              </div> */}
              <div className="font-size-sm text-muted mt-2">
                Bulan {monthName()}
              </div>
            </div>
          </div>
          {/* <div className="card-toolbar">
            <Dropdown className="dropdown-inline" alignRight>
              <Dropdown.Toggle
                className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                variant="transparent"
                id="dropdown-toggle-top"
                as={DropdownCustomToggler}
              >
                <i className="ki ki-bold-more-hor" />
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                <ul className="navi navi-hover py-5">
                  <li className="navi-item">
                    <a href="#" className="navi-link">
                      <span className="navi-icon">
                        <i className="flaticon2-drop"></i>
                      </span>
                      <span className="navi-text">1 Minggu</span>
                    </a>
                  </li>
                  <li className="navi-item">
                    <a href="#" className="navi-link">
                      <span className="navi-icon">
                        <i className="flaticon2-list-3"></i>
                      </span>
                      <span className="navi-text">1 Bulan</span>
                    </a>
                  </li>
                  <li className="navi-item">
                    <a href="#" className="navi-link">
                      <span className="navi-icon">
                        <i className="flaticon2-rocket-1"></i>
                      </span>
                      <span className="navi-text">1 Tahun</span>
                    </a>
                  </li>
                </ul>
              </Dropdown.Menu>
            </Dropdown>
          </div> */}
        </div>
        {/* end::Header */}

        {/* begin::Body */}
        <div className="card-body d-flex flex-column px-0">
          {/* begin::Chart */}
          <div
            id="kt_tiles_widget_1_chart"
            data-color={chartColor}
            style={{ height: "150px" }}
          />
          {/* end::Chart */}
        </div>
        {/* end::Body */}
      </div>
      {/* end::Tiles Widget 1 */}
    </>
  );
}

function getChartOption(layoutProps, donation, date) {
  //   console.log("data", data);
  const options = {
    chart: {
      type: "line",
      height: 250,
      toolbar: {
        show: true,
      },
    },
    series: [
      {
        name: "Transaksi Donasi",
        data: donation,
      },
    ],
    xaxis: {
      categories: date,
    },
    yaxis: {
      labels: {
        formatter: function(val, index) {
          return currencyFormatter(val);
        },
      },
    },
  };
  return options;
}
